<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @printTag="printTag"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .stockSampleLocationListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    printTag() {
      this.$refs.main.printTag()
    }
  }
}
</script>
